/**
 * Based on https://www.gs1.org/services/how-calculate-check-digit-manually
 */

const calculateCheckDigit = (digits: number[]): number =>
  (10 -
    ([...digits]
      .reverse()
      .slice(1)
      .reduce((sum, digit, i) => sum + digit * (i % 2 ? 1 : 3), 0) %
      10)) %
  10

class GTIN {
  private isInvalid: boolean

  private digits: number[]

  constructor(code: string) {
    this.isInvalid = code.match(/^(\d{6}|\d{8}|\d{12,14})$/) === null
    this.digits = code.split('').map(c => Number(c))
  }

  isValid(): boolean {
    return !this.isInvalid && calculateCheckDigit(this.digits) === this.digits.slice(-1)[0]
  }
}

export const isValidGTIN = (code: string): boolean => new GTIN(code).isValid()
